"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ID_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
function randomString(length) {
    var randomText = '';
    for (var i = 0; i < length; i++) {
        randomText += ID_CHARS[Math.floor(Math.random() * ID_CHARS.length)];
    }
    return randomText;
}
exports.randomString = randomString;
